import { Component } from 'react';
import { getUserPoints, getUserPointsNoCache } from '../../service/points.service';
import { Link } from 'react-router-dom';
import { getUserCards } from '../../service/card.service';
import { checkCardIsSelected, getCatalogLength,  returnCardInfo, returnCatalogId } from '../../utilities/common.utilities';
import cardModel from '../../static/card-model';
import './subHeader.component.css';
import { useState } from "react";
import { getCatalogs } from '../../service/catalog.service';


// type subHeaderState = {
//     customerName: string;
//     points: number;
//     cardData: {
//         groupCode: string;
//         storeCode: string;
//         selectedCard: string;
//     },
//     noCardLinked: boolean;
//     isOnline: boolean;
//     catalogsLength: number;
//     recentCatalogPoints: number
// }


type subHeaderState = {
    customerName: string;
    points: number;
    recentCatalogPoints: number;
    oldestCatalogPoints: number;
    oldestCatalogId: string | number;
    cardData: {
        groupCode: string;
        storeCode: string;
        selectedCard: string;
    };
    catalogsLength: number;
    noCardLinked: boolean;
    isOnline: boolean;
};

type Catalog = {
    catalogId: number;
    validToDate: string;
    validFromDate: string;
    bookableUntilDate: string;
};

class SubheaderComponent extends Component<{}, subHeaderState> {

    state: subHeaderState = {
        customerName: '',
        points: 0,
        recentCatalogPoints: 0,
        oldestCatalogPoints: 0,
        oldestCatalogId: -1,
        cardData: {
            groupCode: '',
            storeCode: '',
            selectedCard: ''
        },
        catalogsLength: 0,
        noCardLinked: false,
        isOnline: navigator.onLine
    };    

    constructor(props: any) {
        super(props);
        this.updateOnlineStatus = this.updateOnlineStatus.bind(this); 
    }

    // ****************************************** BACKUP ********************************************************

    // componentDidMount() {
    //     window.addEventListener('online', this.updateOnlineStatus);
    //     window.addEventListener('offline', this.updateOnlineStatus);

    //     getCatalogLength().then(catalogsLength => {
    //         this.setState({ catalogsLength }); // Aggiorna la lunghezza dei cataloghi
    //     });

    //     if(checkCardIsSelected()){
    //         returnCardInfo().then(async card => {
    //             const catalogId = await returnCatalogId();
    //             await getUserPoints(card.groupCode,card.storeCode,card.card, catalogId).then(points => {

    //                     this.setState({
    //                         customerName: card.customerName.toUpperCase(),
    //                         points: points.totalPoints,
    //                         cardData: {
    //                             selectedCard: card.card.toString(),
    //                             groupCode: card.groupCode,
    //                             storeCode: card.storeCode
    //                         }
    //                       }) 
    //             })
              
    //         });
            
    //       } else {
    //         getUserCards().then( async (cardData: cardModel) => {
    //             if(cardData.cards.length > 0) {
    //                 const groupCode = cardData.cards[0].groupId.toString();
    //                 const storeCode = cardData.cards[0].mainStoreCode;
    //                 const card = cardData.cards[0].cardNumber;
    //                 const customerName = cardData.cards[0].customerName;
    //                 const catalogId = await returnCatalogId()

    //                 await getUserPoints(groupCode,storeCode,card, catalogId).then(points => {

    //                     this.setState((state) => ({
    //                         customerName: customerName.toUpperCase(),
    //                         points: points.totalPoints,
    //                         cardData: {
    //                             groupCode: groupCode,
    //                             storeCode: storeCode,
    //                             selectedCard: card
    //                         }
    //                     })); 
    //             });
    //             } else { // no card linked
    //                 this.setState((state) => ({
    //                     noCardLinked: true
    //                 }));
    //             }
                
    //         })
    //       }
          
         
    // }

    // **************************************************************************************************
    
    private async getCardInfo(): Promise<{
        groupCode: string;
        storeCode: string;
        card: string;
        customerName: string;
    } | null> {
        if (checkCardIsSelected()) {
            return await returnCardInfo(); 
        } else {
            const cardData = await getUserCards(); 
            if (cardData.cards.length > 0) {
                const firstCard = cardData.cards[0];
                return {
                    groupCode: firstCard.groupId.toString(),
                    storeCode: firstCard.mainStoreCode,
                    card: firstCard.cardNumber,
                    customerName: firstCard.customerName,
                };
            }
        }
        return null; // Nessuna carta trovata
    }

    private async getCatalogDetails(groupCode: string, storeCode: string, card: string) {
        const catalogs: Catalog[] = await getCatalogs(groupCode, storeCode, card);
    
        if (catalogs.length === 0) {
            console.warn('Nessun catalogo trovato.');
            return { oldestCatalogId: -1, newestCatalogId: -1 };
        }
    
        // Ordina i cataloghi in base a bookableUntilDate
        catalogs.sort((a: Catalog, b: Catalog) => 
            new Date(a.bookableUntilDate).getTime() - new Date(b.bookableUntilDate).getTime()
        );
    
        const oldestCatalog = catalogs[0];
        const newestCatalog = catalogs[catalogs.length - 1];
    
        // console.log('Catalogo più vecchio:', JSON.stringify(oldestCatalog, null, 2));
        // console.log('Catalogo più nuovo:', JSON.stringify(newestCatalog, null, 2) );
    
        return {
            oldestCatalogId: Number(oldestCatalog.catalogId), // Converte catalogId in numero
            newestCatalogId: Number(newestCatalog.catalogId)  // Converte catalogId in numero
        };
    }

    // Funzione per un solo catalogo
    private async fetchSingleCatalogPoints(card: { groupCode: string; storeCode: string; card: string; customerName: string; }): Promise<number> {
        const catalogs = await getCatalogs(card.groupCode, card.storeCode, card.card);
        const singleCatalog = catalogs[0];
        const points = await getUserPoints(card.groupCode, card.storeCode, card.card, singleCatalog.catalogId.toString());
        return points.totalPoints;
    }

    // Funzione per più cataloghi
    private async fetchMultipleCatalogPoints(
        card: { groupCode: string; storeCode: string; card: string; customerName: string; },
        oldestCatalogId: number,
        newestCatalogId: number
    ): Promise<{ recentPoints: number; oldestPoints: number }> {
        const [recentPointsRes, oldestPointsRes] = await Promise.all([
            getUserPointsNoCache(card.groupCode, card.storeCode, card.card, newestCatalogId.toString()),
            getUserPointsNoCache(card.groupCode, card.storeCode, card.card, oldestCatalogId.toString())
        ]);
        return {
            recentPoints: recentPointsRes.totalPoints,
            oldestPoints: oldestPointsRes.totalPoints
        };
    }
    
    async componentDidMount() {
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    
        try {
            const catalogsLength = await getCatalogLength();
            this.setState({ catalogsLength });

            const card = await this.getCardInfo();
            if (!card) {
                console.error('Errore: nessuna carta disponibile.');
                this.setState({ noCardLinked: true });
                return;
            }

            // Caso con un solo catalogo
            if (catalogsLength === 1) {
                // const catalogs = await getCatalogs(card.groupCode, card.storeCode, card.card);
                
                // const singleCatalog = catalogs[0];
                // const points = await getUserPoints(card.groupCode, card.storeCode, card.card, singleCatalog.catalogId.toString());
                
                // this.setState({
                //     customerName: card.customerName.toUpperCase(),
                //     points: points.totalPoints,
                //     recentCatalogPoints: points.totalPoints, // Punti del singolo catalogo
                //     cardData: {
                //         selectedCard: card.card.toString(),
                //         groupCode: card.groupCode,
                //         storeCode: card.storeCode,
                //     }
                // });
                // return; // Termina qui perché non ci sono altri cataloghi
                const singleCatalogPoints = await this.fetchSingleCatalogPoints(card);
                this.setState({
                    customerName: card.customerName.toUpperCase(),
                    points: singleCatalogPoints,
                    recentCatalogPoints: singleCatalogPoints,
                    cardData: {
                        selectedCard: card.card.toString(),
                        groupCode: card.groupCode,
                        storeCode: card.storeCode,
                    }
                });
                return;                 
            } else if (catalogsLength > 1) {
                // Caso con più cataloghi
                const { oldestCatalogId, newestCatalogId } = await this.getCatalogDetails(card.groupCode, card.storeCode, card.card);
                
                if (oldestCatalogId === -1 || newestCatalogId === -1) {
                    console.warn('Non sono stati trovati cataloghi validi.');
                    return;
                }

                const { recentPoints, oldestPoints } = await this.fetchMultipleCatalogPoints(card, oldestCatalogId, newestCatalogId);

                this.setState({
                    customerName: card.customerName.toUpperCase(),
                    points: recentPoints || 0,
                    recentCatalogPoints: recentPoints || 0,
                    oldestCatalogId,
                    oldestCatalogPoints: oldestPoints || 0,
                    cardData: {
                        selectedCard: card.card.toString(),
                        groupCode: card.groupCode,
                        storeCode: card.storeCode
                    }
                });
            }
    
            // Caso con più cataloghi
            // Recupera i dettagli sui cataloghi
            // const { oldestCatalogId, newestCatalogId } = await this.getCatalogDetails(card.groupCode, card.storeCode, card.card);
    
            // if (oldestCatalogId === -1 || newestCatalogId === -1) {
            //     console.warn('Non sono stati trovati cataloghi validi.');
            //     return;
            // }
    
            // // Recupera punti per i cataloghi più vecchio e più recente contemporaneamente
            // const [recentPoints, oldestPoints] = await Promise.all([
            //     getUserPoints(card.groupCode, card.storeCode, card.card, newestCatalogId.toString()),
            //     getUserPoints(card.groupCode, card.storeCode, card.card, oldestCatalogId.toString())
            // ]);
    
            // Aggiorna lo stato una sola volta
            // this.setState({
            //     customerName: card.customerName.toUpperCase(),
            //     points: recentPoints.totalPoints, // Punti del catalogo più recente
            //     recentCatalogPoints: recentPoints.totalPoints,
            //     oldestCatalogId: oldestCatalogId,
            //     oldestCatalogPoints: oldestPoints.totalPoints, // Punti del catalogo più vecchio
            //     cardData: {
            //         selectedCard: card.card.toString(),
            //         groupCode: card.groupCode,
            //         storeCode: card.storeCode
            //     }
            // });
            // this.setState({
            //     customerName: card.customerName.toUpperCase(),
            //     points: recentPoints.totalPoints || 0,
            //     recentCatalogPoints: recentPoints.totalPoints || 0,
            //     oldestCatalogId,
            //     oldestCatalogPoints: oldestPoints.totalPoints || 0,
            //     cardData: {
            //         selectedCard: card.card.toString(),
            //         groupCode: card.groupCode,
            //         storeCode: card.storeCode
            //     }
            // });
        } 
        // catch (error) {
        //     console.error('Errore durante il recupero delle informazioni:', error);
        // }
        catch (error) {
            console.error('Errore durante il recupero delle informazioni:', error);
            this.setState({ noCardLinked: true, recentCatalogPoints: 0, oldestCatalogPoints: 0 });
        }
    }
    
    

    componentWillUnmount(): void {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    }

    updateOnlineStatus() {
        this.setState({isOnline: navigator.onLine})
    }
    
    render() {
        return (
            
            <div className={'subHeader ' + (this.state.isOnline ? '' : 'subHeader-offline')}>

                <div className="flex overflow-hidden mt-2">
                    <div className="flex-none flex align-items-center justify-content-center ml-2">
                        <div className="flex flex-column">
                            <div className="flex align-items-center justify-content-center">
                            <Link className='decoration-subheader'  to={{pathname:"/fidelity-card"}} state={{cardData: this.state.cardData}}>
                                <div  className='bi bi-person-vcard-fill subheader-card-icon flex align-items-center justify-content-center font-bold' id='subHeaderCard'></div>
                                {/* <img src="EXPERIENCE_APP_ICONE_carta_fedelta.png" className='flex align-items-center justify-content-center font-bold' id='subHeaderCard' alt="fidelityCard" style={{ width: 'auto', height: '30px' }} /> */}
                            </Link>
                            </div>
                            <div className="flex align-items-center justify-content-center font-bold">
                                <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="subHeaderCard">CARD</label>
                            </div>
                        </div>
                    </div>
                    
                    
                    <div className="flex-grow-1 flex align-items-center justify-content-start">
                    <Link to={{pathname:"/fidelity-card"}} state={{cardData: this.state.cardData}} style={{all: 'unset', cursor:'pointer'}}>
                        <div className="customerName font-bold ml-2">{this.state.customerName}</div> {/*text-2xl*/}
                    </Link>
                    </div>
                    
                    
                    <div className="flex-none flex align-items-center justify-content-end mr-2" >
                        <div className="flex flex-column">
                        <Link to={{pathname:"/rewards-points"}} state={{cardData: this.state.cardData}} style={{all: 'unset', cursor:'pointer'}}>
                            <div className="flex align-items-center justify-content-center">
                                <div  className='bi bi-trophy subheader-trophy-icon flex align-items-center justify-content-center font-bold' id='subHeaderPoint'  />
                                {/* <img src="EXPERIENCE_APP_ICONE_punti_premi.png" className='flex align-items-center justify-content-center font-bold' id='subHeaderPoint' alt="fidelityCard" style={{ width: 'auto', height: '25px' }} /> */}
                            </div>
                            <div className="flex align-items-center justify-content-center font-bold">
                                <label style={{ fontSize: '8px', fontWeight: 'bold' }} htmlFor="subHeaderPoint">PUNTI</label>
                            </div>
                        </Link>
                        
                        </div>

                        { 
                            this.state.catalogsLength === 1  ? (
                                // Caso con un solo catalogo
                                <div className="flex flex-column">
                                    <div className="font-bold text-2xl ml-2">{this.state.points }</div>
                                </div>
                            )
                            :
                            // Se ci sono più cataloghi 
                            this.state.catalogsLength > 1 ? (
                                <div>

                                    <Link to={{ pathname: "/rewards-points" }} state={{ cardData: this.state.cardData }} style={{ all: 'unset', cursor: 'pointer' }}>
                                        <div className="points-wrap">
                                            {/* <div className="points-col"> */}
                                            <div  className="font-bold text-2xl ml-2 points-catalogs">{this.state.recentCatalogPoints}</div>
                                                {/* <div className="sr-only">PUNTI</div> */}
                                            {/* </div> */}

                                            <div className="v-sep" aria-hidden="true"></div>

                                                <div className="flex flex-column justify-content-center align-items-center " >
                                                    <div style={{ fontSize: '14px' }} className="font-bold ">{this.state.oldestCatalogPoints}</div>
                                                    <div style={{ fontSize: '10px' }}>In scadenza</div>
                                                </div>
                                        </div>
                                    </Link>
                                    {/* <Link to={{pathname:"/rewards-points"}} state={{cardData: this.state.cardData}} style={{all: 'unset', cursor:'pointer'}}>
                                        <div className="flex flex-column align-items-center">
                                            <div className="font-bold text-2xl ml-2 points-catalogs">{this.state.recentCatalogPoints }</div>
                                            <div className='flex ml-2' style={{ fontSize: '10px' }}>
                                                <div  >In Scadenza </div>
                                                <div className='font-bold ml-1'> {this.state.oldestCatalogPoints } </div> 
                                            </div>
                                        </div>
                                    </Link> */}

                                </div>
                            )
                            :
                            <></>
                        }

                    </div>
                </div>

            </div>            
            
        );
    }
}

export default SubheaderComponent;